
// check if there is a 401 error and show (if any) included error, else use the provided message
const unauthorizedMessageOrProvided = (error, message) => {
  if (error) {
    if (error.response.status === 401 && error.response.data && error.response.data.error) {
      return error.response.data.error;
    }
    return message;
  }
};


export { unauthorizedMessageOrProvided };
